module.exports = __webpack_public_path__ + "fonts/open-sans-v18-latin-regular.5f4d4bc1.eot";